export const countryToLang = {
  TR: "tr",
  TURKEY: "tr",
  ES: "es",
  SPAIN: "es",
  FR: "fr",
  FRANCE: "fr",
  IT: "it",
  ITALY: "it",
  PT: "pt",
  PORTUGAL: "pt",
  CN: "cn",
  CHINA: "cn",
  US: "en",
  GB: "en",
  "UNITED STATES": "en",
  "UNITED KINGDOM": "en",
  AR: "es",
  ARGENTINA: "es",
};


export const countryToAudioLang = {
  TR: "tur",
  TURKEY: "tur",
  ES: "spa",
  SPAIN: "spa",
  FR: "fra",
  FRANCE: "fra",
  IT: "ita",
  ITALY: "ita",
  PT: "por",
  PORTUGAL: "por",
  CN: "chi",
  CHINA: "chi",
  US: "eng",
  GB: "eng",
  "UNITED STATES": "eng",
  "UNITED KINGDOM": "eng",
  AR: "spa",
  ARGENTINA: "spa",
};

export const getUserLangFromAudioLang = (audioLang) => {
  const reverseMap = {
    eng: "en",
    spa: "es",
    fra: "fr",
    ita: "it",
    por: "pt",
    tur: "tr",
    chi: "cn",
    arg: "es",
  };
  return reverseMap[audioLang] || "en";
};
